export const tagColorOptions = ['green', 'blue', 'orange', 'red', 'gray', 'black', 'white'];
